function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import { getSymbols as d } from "../compat/_internal/getSymbols.js";
import { getTag as m } from "../compat/_internal/getTag.js";
import { uint32ArrayTag as a, uint16ArrayTag as w, uint8ClampedArrayTag as A, uint8ArrayTag as h, symbolTag as O, stringTag as b, setTag as x, regexpTag as B, objectTag as D, numberTag as P, mapTag as S, int32ArrayTag as M, int16ArrayTag as E, int8ArrayTag as F, float64ArrayTag as I, float32ArrayTag as R, dateTag as W, booleanTag as L, dataViewTag as j, arrayBufferTag as q, arrayTag as z, argumentsTag as G } from "../compat/_internal/tags.js";
import { isPrimitive as H } from "../predicate/isPrimitive.js";
import { isTypedArray as J } from "../predicate/isTypedArray.js";
function Z(r, n) {
  return c(r, void 0, r, new Map(), n);
}
function c(r, n, f) {
  var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new Map();
  var g = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : void 0;
  var y = g === null || g === void 0 ? void 0 : g(r, n, f, i);
  if (y != null) return y;
  if (H(r)) return r;
  if (i.has(r)) return i.get(r);
  if (Array.isArray(r)) {
    var t = new Array(r.length);
    i.set(r, t);
    for (var s = 0; s < r.length; s++) t[s] = c(r[s], s, f, i, g);
    return Object.hasOwn(r, "index") && (t.index = r.index), Object.hasOwn(r, "input") && (t.input = r.input), t;
  }
  if (r instanceof Date) return new Date(r.getTime());
  if (r instanceof RegExp) {
    var _t = new RegExp(r.source, r.flags);
    return _t.lastIndex = r.lastIndex, _t;
  }
  if (r instanceof Map) {
    var _t2 = new Map();
    i.set(r, _t2);
    var _iterator = _createForOfIteratorHelper(r),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _ref = _step.value;
        var _ref2 = _slicedToArray(_ref, 2);
        var _s = _ref2[0];
        var p = _ref2[1];
        _t2.set(_s, c(p, _s, f, i, g));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return _t2;
  }
  if (r instanceof Set) {
    var _t3 = new Set();
    i.set(r, _t3);
    var _iterator2 = _createForOfIteratorHelper(r),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _s2 = _step2.value;
        _t3.add(c(_s2, void 0, f, i, g));
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return _t3;
  }
  if ((typeof Buffer === "undefined" ? "undefined" : _typeof(Buffer)) < "u" && Buffer.isBuffer(r)) return r.subarray();
  if (J(r)) {
    var _t4 = new (Object.getPrototypeOf(r).constructor)(r.length);
    i.set(r, _t4);
    for (var _s3 = 0; _s3 < r.length; _s3++) _t4[_s3] = c(r[_s3], _s3, f, i, g);
    return _t4;
  }
  if (r instanceof ArrayBuffer || (typeof SharedArrayBuffer === "undefined" ? "undefined" : _typeof(SharedArrayBuffer)) < "u" && r instanceof SharedArrayBuffer) return r.slice(0);
  if (r instanceof DataView) {
    var _t5 = new DataView(r.buffer.slice(0), r.byteOffset, r.byteLength);
    return i.set(r, _t5), e(_t5, r, f, i, g), _t5;
  }
  if ((typeof File === "undefined" ? "undefined" : _typeof(File)) < "u" && r instanceof File) {
    var _t6 = new File([r], r.name, {
      type: r.type
    });
    return i.set(r, _t6), e(_t6, r, f, i, g), _t6;
  }
  if (r instanceof Blob) {
    var _t7 = new Blob([r], {
      type: r.type
    });
    return i.set(r, _t7), e(_t7, r, f, i, g), _t7;
  }
  if (r instanceof Error) {
    var _t8 = new r.constructor();
    return i.set(r, _t8), _t8.message = r.message, _t8.name = r.name, _t8.stack = r.stack, _t8.cause = r.cause, e(_t8, r, f, i, g), _t8;
  }
  if (_typeof(r) == "object" && K(r)) {
    var _t9 = Object.create(Object.getPrototypeOf(r));
    return i.set(r, _t9), e(_t9, r, f, i, g), _t9;
  }
  return r;
}
function e(r, n) {
  var f = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : r;
  var i = arguments.length > 3 ? arguments[3] : undefined;
  var g = arguments.length > 4 ? arguments[4] : undefined;
  var y = [].concat(_toConsumableArray(Object.keys(n)), _toConsumableArray(d(n)));
  for (var t = 0; t < y.length; t++) {
    var s = y[t],
      p = Object.getOwnPropertyDescriptor(r, s);
    (p == null || p.writable) && (r[s] = c(n[s], s, f, i, g));
  }
}
function K(r) {
  switch (m(r)) {
    case G:
    case z:
    case q:
    case j:
    case L:
    case W:
    case R:
    case I:
    case F:
    case E:
    case M:
    case S:
    case P:
    case D:
    case B:
    case x:
    case b:
    case O:
    case h:
    case A:
    case w:
    case a:
      return !0;
    default:
      return !1;
  }
}
export { Z as cloneDeepWith, c as cloneDeepWithImpl, e as copyProperties };